import MainLayout from "@/components/layout/MainLayout.vue";
import { required, maxLength, numeric, minValue, maxValue } from "vuelidate/lib/validators";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    name: "contentEdit",

    components: {
        MainLayout
    },

    data() {
        return {
            courseId: null,
            contentGroupId: null,
            contentId: null,

            contentData: {
                course_title: "",
                gp_name: "",
                content_title: "",
                order: ""
            },
            submitted: false,
            validation: false,
        };
    },

    validations: {
        contentData: {
            content_title: {
                required,
                maxLength: maxLength(100)
            },
            order: {
                numeric,
                minValue: minValue(1),
                maxValue: maxValue(10000),
                notStartWithZero(value) {
                    if (!value) return true;
                    return !/^0\d+/.test(value);
                }
            }
        }
    },

    computed: {
        ...mapGetters(["userType"])
    },

    methods: {
        submit() {
            if (this.submitted) {
                return;
            }
            this.submitted = true;
            if (this.$v.contentData.$invalid) {
                this.validation = true;
                this.submitted = false;
                return;
            }
            this.saveContent();
        },

        saveContent() {
            const request = {
                content_title: this.contentData.content_title,
                order: this.contentData.order
            };

            axios.post(
                "my/course/" + this.courseId +
                "/content-gp/" + this.contentGroupId +
                "/content/" + this.contentId + "/update",
                request,
                { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
                if (response.data?.status === "success") {
                    this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$router.push({
                        name: "contentList",
                        params: {
                            courseId: this.courseId,
                            id: this.contentGroupId
                        }
                    });

                } 
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    this.$store.commit("logout");
                    window.location.replace("/");
                }
                this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                    timer: 3,
                    position: "bottomCenter"
                });
            });
        },

        loadContent() {
            axios.get(
                "my/course/" + this.courseId +
                "/content-gp/" + this.contentGroupId +
                "/content/" + this.contentId
            )
            .then(response => {
                this.contentData.course_title = response.data.course_title;
                this.contentData.gp_name = response.data.content_group_name;
                this.contentData.content_title = response.data.content_title;
                this.contentData.order = response.data.order;
            })
            .catch(error => {
                if (error.response?.status === 404) {
                    this.$router.push({ name: "notFound" });
                }
                if (error.response?.status === 403) {
                    this.$router.push({ name: "forbidden" });
                }
                if (error.response?.status === 401) {
                    this.$store.commit("logout");
                    window.location.replace("/");
                }
                console.log("Load content error", error);
            });
        },

        goToContentList() {
            this.$router.push({
                name: "contentList",
                params: {
                    courseId: this.courseId,
                    id: this.contentGroupId
                }
            });
        }
    },

    mounted() {
        this.courseId = this.$route.params.courseId;
        this.contentGroupId = this.$route.params.contentGroupId;
        this.contentId = this.$route.params.contentId;
        this.loadContent();
    }
};
